export default class LtikeCommon {
    static PREFIX = "ltike-widget-ph";
    static IMAGE_URL = "https://img2.tour.l-tike.com/image/common/pc/";
    static get API(){
        return {
            TIMEOUT:120000,
            TOP: "https://tour.l-tike.com/api/top",
            AIRPLANE_TICKET:"https://tour.l-tike.com/api/airsearch",
            HOTEL_SEARCH:"https://tour.l-tike.com/api/hotelsearch",
            HOTEL_FILTER:"https://tour.l-tike.com/api/hotelspecifypage"
        };
    }

    static get TEXT(){
        return{
            POINT:"ポイント",
            BONUS_POINT:"ボーナスポイント",
            ERROR_API_TITLE:"エラー",
            ERROR_API_BODY:"apiの読み込みに失敗しました。",
            ERROR_PASSENGER_YEARS_OLD_UNKNOWN:"子供の年齢を選択して下さい",
            ERROR_API_ERROR:"apiの呼び出しに失敗しました"
        };
    }
    static get AIRPLANE(){
        return{
            DEFAULT_DATE:{
                going:0,
                back:2
            },
            DEFAULT_AIRPORT:{
                FROM:"NRT",
                TO:"CTS"
            },
            DEFAULT_AIRPORT_LIST:{
                NORMAL:[
                    "CTS", "KUH", "SYO", "SDJ", "NRT",
                    "KIJ", "NGO", "KIX", "HIJ", "TAK",
                    "KCZ", "MYJ", "FUK", "HSG", "OIT",
                    "NGS", "KMJ", "KMI", "KOJ", "ASJ",
                    "SHI", "OKA", "ISG"
                ],
                POPULAR:[
                    "NRT","CTS","KIX"
                ]
            },
            RECOMMEND_TICKET_LIST:[
                {from:"NRT",to:"CTS"},
                {from:"NRT",to:"FUK"},
                {from:"NRT",to:"OKA"},
                {from:"NRT",to:"KIX"},
                {from:"NRT",to:"KOJ"},
                {from:"KIX",to:"CTS"},
                {from:"KIX",to:"OKA"},
                {from:"KIX",to:"FUK"},
                {from:"KIX",to:"KOJ"},
                {from:"NGO",to:"CTS"},
                {from:"NGO",to:"FUK"},
                {from:"NGO",to:"OKA"},
                {from:"SDJ",to:"CTS"},
                {from:"SDJ",to:"KIX"},
                {from:"FUK",to:"CTS"},
                {from:"FUK",to:"OKA"}
            ],
            RELOAD_TIME: 30*60*1000,
            TEXT:{
                TIMEOUT_ERROR:"検索後30分が経過しました。再検索します。",
                MODAL_AIRPORT_POPULAR_TITLE:"よく利用される空港",
                MODAL_AIRPORT_DEFAULT:"未設定",
                MODAL_PASSENGER_ERROR1:"幼児(座席なし)が大人の人数を上回っています",
                MODAL_PASSENGER_ERROR2:"幼児(座席なし)は合計2人までしか予約できません",
                IT015_TICKET_PRICE_TITLE_ADULT:"大人",
                IT015_TICKET_PRICE_TITLE_CHILD:"子供",
                IT015_TICKET_PRICE_TITLE_INFANT:"幼児",
                IT015_TICKET_PRICE_TITLE_SW:"空港利用料等",
                IT015_TICKET_PRICE_TITLE_TAX:"税金",
                IT015_TICKET_PRICE_TITLE_YQ:"燃料サーチャージ等",
                IT015_TICKET_PRICE_TITLE_COMMISION:"販売手数料",
                SEARCH_SUBMIT_ERROR_DEPARTURE:"出発地を設定してください",
                SEARCH_SUBMIT_ERROR_DESTINATION:"目的地を設定してください",
            }
        };
    }
}